import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { Injectable } from '@angular/core';
import { AppNotificationComponent } from '../app-notification/app-notification.component';
import { ToastrService } from 'ngx-toastr';
import { CustomToast } from './toast';
//import { OrderService } from '../../../views/order/order.service';
import { DataService } from '../../services/data.service';

interface confirmData {
  title?: string;
  message?: string;
  type?: string;
  action?: any;
  idNotification?: any;
  idReminder?: any;
}
var snackbarRef;
@Injectable({ providedIn: 'root' })
export class AppNotificationService {
  constructor(
    private _snackbar: MatSnackBar,
    private toastr: ToastrService,
   // private order: OrderService,
    private pass: DataService
  ) {}

  public notification(data: confirmData = {}) {
    data.title = data.title || 'Chưa có tiêu đề';
    data.message = data.message || 'Chưa có nội dung';
    data.type = data.type || 'callBack';
    data.action = data.action || null;
    data.idNotification = data.idNotification || null;
    data.idReminder = data.idReminder || null;
    // snackbarRef = this._snackbar.openFromComponent(AppNotificationComponent, {
    //   duration: 0,
    //   data: {
    //     message: data.message,
    //     type: data.type,
    //     title: data.title,
    //     action: data.action,
    //   },
    //   horizontalPosition: 'right',
    //   verticalPosition: 'top',
    //   panelClass: 'mat-snackbar',
    // });
    // this.toastr.success('Hello world!', 'Toastr fun!', {
    //   timeOut: 0,
    //   extendedTimeOut: 0,
    // });
    const opt: any = { timeOut: 0, extendedTimeOut: 0 };
    opt.toastComponent = CustomToast;
    opt.toastClass = 'pinktoast';
    const toast = this.toastr.show(data.message, data.title, opt);
    toast.toastRef.componentInstance.data = {
      type: data.type,
      action: data.action,
      title: data.title,
      message: data.message,
      toastId: toast.toastId,
    };
    this.showNotificationBrowser(data);
  }

  public close() {
    snackbarRef.dismiss();
  }

  public showNotificationBrowser(data: confirmData = {}) {
    if (window.Notification && Notification.permission === 'granted') {
      this.createNotification(data);
    } else if (window.Notification && Notification.permission !== 'denied') {
      Notification.requestPermission(function (status) {
        if (status === 'granted') {
          this.createNotification(data);
        }
      });
    }
  }

  createNotification(data: confirmData = {}) {
    const notification = new Notification(data.title, {
      tag: data.title,
      silent: true,
      renotify: true,
      data,
      body: data.message,
    });
    notification.onclick = (event: any) => {
      const { target } = event;
      const { data } = target;

      if (data.action) {
        // if (data.action.idNotification) {
        //   this.order
        //     .updateReadStatusNotification(data.action.idNotification)
        //     .subscribe((res) => {});
        //   this.pass.changeTypeLoad('1');
        // }
        // if (data.action.idReminder) {
        //   this.order
        //     .updateReadStatusReminder(data.action.idReminder)
        //     .subscribe((res) => {});
        //   this.pass.changeTypeLoad('2');
        // }
        // const duplicate = data.type === 'dup' ? '&duplicate=true' : '';
        // window.open(`/order?id=${data.action.idOrder}${duplicate}`, 'blank');
      } else {
        parent.focus();
        window.focus();
      }
    };
  }
}
